// extracted by mini-css-extract-plugin
module.exports = {"competitionLogo":"_2Om3R","competitionLogoImg":"_1Gw__"};